/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
 */
export interface AnalyzeInvoiceOfPaymentRequests200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'accountType': AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'companyName': string | null;
}

export const AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum = typeof AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum[keyof typeof AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum];


